<template>
  <TwoColPageWrapper :breadcrumbs="breadcrumbs" leftBanner>
    <h1>Калькулятор расхода</h1>

    <div class="calculator-product-select-wrapper">
      <div v-if="!selItem" class="title font-weight-bold">Выберите продукт</div>
      <div v-else class="d-flex justify-space-between align-center">
        <div class="title font-weight-bold">{{ selItem.label }}</div>
        <v-btn class="yellow" depressed small @click="selItem = null"
          >назад</v-btn
        >
      </div>

      <v-slide-y-reverse-transition mode="out-in">
        <div v-if="!selItem" class="calculator-product-select-list" :key="1">
          <table>
            <tbody>
              <tr>
                <td v-for="(item, index) in calcItems" :key="index">
                  <p
                    style="background-image: url(/upload/iblock/66f/66f88b6a73ce10d2010fda0ed18a2d51.png)"
                    class="td-title d-flex align-center"
                  >
                    {{ item.label }}
                  </p>
                  <a
                    v-for="(itm, i) in item.items"
                    :key="i"
                    href="#"
                    @click.prevent="selItem = { ...itm }"
                    >{{ itm.label }}</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <component
          :is="selItem.calcName"
          v-else
          :key="2"
          :multiplier="selItem.calcOpt && selItem.calcOpt.multiplier"
          :multiplier1="selItem.calcOpt && selItem.calcOpt.multiplier1"
          :multiplier2="selItem.calcOpt && selItem.calcOpt.multiplier2"
          :minThickness="selItem.calcOpt && selItem.calcOpt.minThickness"
          :kg5="selItem.calcOpt && selItem.calcOpt.kg5"
          :kg10="selItem.calcOpt && selItem.calcOpt.kg10"
          :kg25="selItem.calcOpt && selItem.calcOpt.kg25"
          :kit="selItem.calcOpt && selItem.calcOpt.kit"
          :tile40="selItem.calcOpt && selItem.calcOpt.tile40"
          :tile60="selItem.calcOpt && selItem.calcOpt.tile60"
        >
        </component>
      </v-slide-y-reverse-transition>
    </div>

    <p>
      Компания Sika представляет калькулятор сухих строительных смесей. С
      помощью удобного онлайн-сервиса вы легко рассчитаете нужное количество
      материалов для любого вида строительных и отделочных работ.
    </p>
    <p>
      Расчет сухой смеси – важный этап перед началом строительства, ведь покупка
      материалов «на глаз» приводит к лишним денежным тратам или к задержке
      работ, а в некоторых случаях к нарушению технологического процесса и
      браку.
    </p>
    <h2>Как использовать калькулятор расхода сухих смесей?</h2>
    <p>
      Вы можете использовать сервис, как калькулятор цементной стяжки пола,
      полимерных напольных покрытий, добавок в бетон, гидроизоляционных и других
      смесей. Во всех случаях расчет стройматериала требует нескольких простых
      действий:
    </p>
    <ol>
      <li>Выберите продукт из приведенного списка.</li>
      <li>Укажите толщину слоя в мм и площадь поверхности в м<sup>2</sup>.</li>
      <li>Кликните кнопку «рассчитать».</li>
    </ol>
    <p>
      Калькулятор строительных смесей выдаст готовые расчеты с указанием общей
      массы материала и необходимого количества мешков весом по 25 кг.
    </p>
    <p>
      Швейцарский концерн Sika – один из мировых лидеров в области производства
      модифицирующих добавок в бетон и сухих смесей для устройства цементных и
      полимерных стяжек пола, гидроизоляции, укладки плитки, отделки стен и
      фасадов и других работ. Компания Sika гарантирует высокое качество своей
      продукции при условии соблюдения расчетных параметров и строительных
      технологий.
    </p>
  </TwoColPageWrapper>
</template>

<script>
import Calc1 from "@/components/calc/Calc1.vue";
import Calc2 from "@/components/calc/Calc2.vue";
import Calc3 from "@/components/calc/Calc3.vue";
import Calc4 from "@/components/calc/Calc4.vue";
import Calc5 from "@/components/calc/Calc5.vue";

export default {
  components: {
    Calc1,
    Calc2,
    Calc3,
    Calc4,
    Calc5,
  },
  data() {
    return {
      calcItems: [
        {
          label: "Полы и напольные покрытия",
          items: [
            {
              label: "Sikafloor® Screed-100",
              calcName: "Calc1",
              calcOpt: {
                multiplier: 1.8,
                minThickness: 2,
                kg25: true,
              },
            },
            {
              label: "Sika® Level Universal",
              calcName: "Calc1",
              calcOpt: {
                multiplier: 1.75,
                minThickness: 2,
                kg25: true,
              },
            },
            {
              label: "Sika® Level Pro",
              calcName: "Calc1",
              calcOpt: {
                multiplier: 1.7,
                minThickness: 2,
                kg25: true,
              },
            },
            {
              label: "Sika® Primer Pro",
              calcName: "Calc1",
              calcOpt: {
                multiplier: 0.15,
                minThickness: 1,
                kg5: true,
                kg10: true,
              },
            },
          ],
        },
        {
          label: "Гидроизоляция",
          items: [
            {
              label: "Sika®-101а",
              calcName: "Calc2",
              calcOpt: {
                multiplier1: 6.3,
                multiplier2: 5.2,
              },
            },
            {
              label: "Sika® TopSeal-107",
              calcName: "Calc2",
              calcOpt: {
                multiplier1: 5.7,
                kit: true,
              },
            },
            {
              label: "Sika® Igolflex N",
              calcName: "Calc2",
              calcOpt: {
                multiplier1: 3,
                kit: true,
              },
            },
            {
              label: "SikaMur® Injectocream",
              calcName: "Calc3",
            },
          ],
        },
        {
          label: "Укладка плитки",
          items: [
            {
              label: "SikaCeram® Standard",
              calcName: "Calc4",
            },
            {
              label: "SikaCeram® Universal",
              calcName: "Calc4",
              calcOpt: {
                tile40: true,
              },
            },
            {
              label: "SikaCeram® Pro",
              calcName: "Calc4",
              calcOpt: {
                tile40: true,
              },
            },
            {
              label: "SikaCeram® Fix",
              calcName: "Calc4",
              calcOpt: {
                tile40: true,
                tile60: true,
              },
            },
            {
              label: "SikaCeram® UltraFix",
              calcName: "Calc4",
              calcOpt: {
                tile40: true,
                tile60: true,
              },
            },
            {
              label: "SikaCeram® Elastic",
              calcName: "Calc4",
              calcOpt: {
                tile40: true,
                tile60: true,
              },
            },
            {
              label: "SikaCeram® Rapid",
              calcName: "Calc4",
              calcOpt: {
                tile40: true,
                tile60: true,
              },
            },
          ],
        },
        {
          label: "Добавки в бетон",
          items: [
            {
              label: "Sikament® BV 3M",
              calcName: "Calc5",
            },
            {
              label: "Sika® Mix Plus",
              calcName: "Calc5",
            },
            {
              label: "Sika® Antifreеze N9",
              calcName: "Calc5",
            },
            {
              label: "Sika® Antifreeze FS-1",
              calcName: "Calc5",
            },
          ],
        },
      ],
      selItem: null,
      breadcrumbs: [
        {
          label: "Главная",
          to: { name: "main" },
        },
        {
          label: "Калькулятор",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.calculator-product-select-wrapper {
  min-height: 400px;
}
</style>
